import Vue from 'vue'
import App from './app'
import VueResource from 'vue-resource'

;(function initApp () {
  Vue.use(VueResource)

  var app = new Vue({
    el: '#app',
    template: '<App></App>',
    components: {
      App
    }
  })

  window._chatapp = app
})()



// WEBPACK FOOTER //
// ./src/pages/main/main.js